import { useMemo } from 'react'

import { UseFlowResponse } from '@cash-web/shared-blocker-feature-main'
import { ModalVariant } from '@cash-web/shared-feature-modal'
import { BlockerType } from '@cash-web/shared-flow-data-access-context'
import { JourneyData, JourneyTarget } from '@cash-web/shared-journey-util-main'

import { JourneyStore, useJourneyStoreSyncOnBlockerChange } from './JourneyStoreProvider'

const targetOverride: Partial<Record<BlockerType, JourneyTarget>> = {
  card_customization: 'fullscreen',
}
export const getModalVariant = (journey: JourneyData): ModalVariant | undefined => {
  return journey.routeConfig?.modalVariant ?? (journey.opts?.['modalVariant'] as ModalVariant | undefined)
}
export const getTarget = (journey: JourneyData, flow?: UseFlowResponse) => {
  const modalVariant = getModalVariant(journey)
  let target = (
    modalVariant === 'fullscreen' ? 'fullscreen' : journey.routeConfig?.target ?? journey.opts?.scope?.['target']
  ) as JourneyTarget | undefined

  const override = flow?.active?.blockerData?.type ? targetOverride[flow.active.blockerData.type] : null
  // override the target if the blocker type is in the targetOverride map
  if (override != null) {
    target = override
  }
  return target
}

export const getTargetHistory = (history: JourneyData[], store?: JourneyStore) => {
  const targetHistory: Partial<Record<JourneyTarget, JourneyData[]>> = {}

  for (const journey of history) {
    const target = getTarget(journey, store?.getSnapshot(journey.journeyId)?.flow) ?? 'modal'
    targetHistory[target] ??= []
    targetHistory[target].push(journey)
  }

  return targetHistory
}

export const useTargetHistory = (history: JourneyData[]) => {
  const { store, syncValue } = useJourneyStoreSyncOnBlockerChange()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getTargetHistory(history, store), [history, store, syncValue])
}
